import React from 'react'

import ErrorMessage from '@/components/misc/ErrorMessage/ErrorMessage'
import { Card, CardContent } from '@/components/ui/card'

interface Props {
  error: unknown
  fallbackComponent?: React.ReactNode
}

const EmbeddedErrorFallback: React.FC<Props> = ({
  error,
  fallbackComponent,
}) => {
  if (fallbackComponent) {
    return fallbackComponent
  }

  return (
    <div className="max-w-3xl">
      <Card>
        <CardContent>
          <ErrorMessage error={error} />
        </CardContent>
      </Card>
    </div>
  )
}

export default EmbeddedErrorFallback
